// Utility to format numbers in Indian format (lakhs, crores)
export const formatIndianCurrency = (amount: number): string => {
  if (amount === 0) return '0';
  
  const numStr = Math.abs(amount).toString();
  const isNegative = amount < 0;
  
  if (numStr.length <= 3) {
    return (isNegative ? '-' : '') + numStr;
  }
  
  // For Indian format: last 3 digits, then groups of 2
  const lastThreeDigits = numStr.slice(-3);
  const otherDigits = numStr.slice(0, -3);
  
  let formattedOtherDigits = '';
  for (let i = otherDigits.length; i > 0; i -= 2) {
    const start = Math.max(0, i - 2);
    const group = otherDigits.slice(start, i);
    formattedOtherDigits = ',' + group + formattedOtherDigits;
  }
  
  return (isNegative ? '-' : '') + formattedOtherDigits.slice(1) + ',' + lastThreeDigits;
};

// Format currency with symbol
export const formatCurrency = (amount: number, symbol: string = '₹'): string => {
  return `${symbol}${formatIndianCurrency(amount)}`;
};

// Format percentage
export const formatPercentage = (value: number, decimals: number = 1): string => {
  return `${value.toFixed(decimals)}%`;
};
